import { useTranslation } from "react-i18next";
import { PageStyles } from "../../layout/Page.styles";

const { Header, Title, Body } = PageStyles;

const SubscriptionsScreen = () => {
  const { t } = useTranslation(undefined, {
    keyPrefix: "screen.subscriptions",
  });

  return (
    <>
      <Header>
        <Title>{t("title")}</Title>
      </Header>
      <Body>{t("bodyPlaceholder")}</Body>
    </>
  );
};

export default SubscriptionsScreen;
